{
  "info": "Információ",
  "negative": "Hiba",
  "notice": "Figyelmeztetés",
  "positive": "Siker"
}
